<script>
	import { pageOffset } from '../../js/model/stores';
	import { animateElement } from '../../js/utils/animate';

	let _lightTop;
	export let direction;
	export let id;
	export let depth = 0.5;

	let animationTop = (value) => {
		animateElement(value, _lightTop, (currentPageOffset) => {
			const scrolledStartSectionPercentage = currentPageOffset * 0.1;
			if(direction != 'ltr') {
				_lightTop.style.transform = `translateX(${Math.max(-50, 50 - scrolledStartSectionPercentage)}%)`;
				return;
			}
			_lightTop.style.transform = `translateX(${Math.min(50, scrolledStartSectionPercentage - 50)}%)`;
		});
	};

	let prepareTop = () => {
		if (!_lightTop) {
			requestAnimationFrame(prepareTop);
			return;
		}

		pageOffset.subscribe(animationTop);
	};

	prepareTop();
</script>

<style>
	svg {
		overflow: visible;
		height: 100%;
	}

	path {
		position: absolute;
	}
</style>

<svg width="78.540108" height="421.259" viewBox="0 0 78.540108 421.259" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g id="{id}">
		<path class="pole"
			  style="fill:#c9468a"
			  id="path4560"
			  d="m 36.1175,83.2588 h 7 V 421.259 h -7 z"/>
		<path class="top" bind:this={_lightTop}
			  style="fill:#c9468a"
			  id="path4564"
			  d="M 78.54011,38.9281 C 78.31181,17.529 60.731614,0 39.270014,0 17.808514,0 0.228317,17.529 0,38.9281 Z"/>
		<path class="bottom"
			  style="fill:#5a97c3"
			  id="path4562"
			  d="M 2e-4,47.8062 H 78.54 C 78.312,69.2052 60.9601,86.7343 39.2703,86.7343 17.5804,86.7343 0.2285,69.4329 2e-4,47.8062 Z"/>
	</g>
</svg>


